<template>
    <div class="wrapper-bg">
        <HeaderOther
            :setTitle="'ประวัติการใช้แต้ม'"
            :setHref="'profile'"
            :showLogo="true"
        />
        <div class="main-layout coffee-nofooter">
            <SelectHistory />
            <FilterDate @afterFilter="afterFilter($event)" />

            <div class="container-history-earn-point">
                <div class="wrapper-table-history-point">
                    <div v-if="historyPoint.length > 0">
                        <div
                            v-for="item in historyPoint"
                            :key="item.id"
                            class="table-history-point-earn"
                        >
                            <div v-if="item.Mission" class="earn-left">
                                <div class="date">
                                    {{ dateTH(item.Timestamp) }}
                                </div>
                                <div class="detail">
                                    คะแนน ที่คุณได้รับ<br />จากการทำภารกิจสำเร็จ
                                </div>
                            </div>
                            <div v-else class="earn-left">
                                <div class="date">
                                    {{ dateTH(item.Timestamp) }}
                                </div>
                                <div
                                    v-if="
                                        item.Detail == 'Ads' ||
                                        item.Detail == 'Ads Survey'
                                    "
                                    class="detail"
                                >
                                    คะแนน ที่คุณได้รับ<br />จากการทำแบบสอบถาม
                                </div>
                                <div
                                    v-else-if="
                                        item.Type == 'trace' && checkType(item)
                                    "
                                    class="detail"
                                >
                                    คะแนน ที่คุณได้รับ<br />
                                    จากการซื้อเครื่องดื่ม {{ item.Points }} แก้ว
                                </div>
                                <div
                                    v-else-if="item.Type == 'trace'"
                                    class="detail"
                                >
                                    คะแนนที่คุณได้รับจากกิจกรรมพิเศษ
                                </div>
                                <div
                                    v-else-if="
                                        item.Type == 'adjust' && item.Message
                                    "
                                    class="detail"
                                >
                                    {{ item.Message }}
                                </div>
                                <div v-else class="detail">
                                    คะแนนที่คุณได้รับ
                                </div>
                            </div>
                            <div class="earn-right">
                                <div style="font-weight: 600">
                                    + {{ item.Points }}
                                </div>
                                <div>
                                    คะแนน
                                    <img src="@/assets/logo-cafe.svg" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-center pt-2" style="color: #fff">
                        ไม่พบประวัติการสะสมคะแนน
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="coffee-bg-footer">
            <img
                style="width: 100%;"
                src="@/assets/bg-cafe-footer.svg"
                alt=""
            />
        </div> -->
    </div>
</template>

<script>
import BzbsHistory from "@/core/History/service/BzbsHistory.js";
import Account from "@/helper/AccountHelper.js";
import HeaderOther from "@/components/Header/HeaderOther.vue";
import SelectHistory from "@/components/Userpoint/SelectHistory.vue";
import BzbsApi from "@/core/Account/service/BzbsProfile.js";
import CacheHelper from "@/helper/CacheHelper.js";
import Locale from "@/helper/locale/locale.js";
import _ from "lodash";
import moment from "moment";
import Mixin from "@/mixin/Mixin";
import FilterDate from "../component/FilterDates.vue";

export default {
    name: "History-earn-point",
    components: {
        HeaderOther,
        SelectHistory,
        FilterDate,
    },
    mixins: [Mixin],
    data: function () {
        return {
            cacheHelper: new CacheHelper(),
            lbl: Locale.getLbl(),
            historyPoint: [],
            getMonth: [],
            yearsRange: [],
            fullDateRange: [],
            fullDatePoint: null,
            nextdataForPointLog: "",
            isshowmorePointLog: false,
            expire_point: {
                points: 0,
                date: null,
                month: null,
                year: null,
            },
            profile: {},
        };
    },
    created: function () {},
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.generateArrayOfYears();
            this.generateArrayOfFulldate();
            this.setCurrentDate();
            window.addEventListener("scroll", this.handleScroll);
            this.isshowmorePointLog = false;
            // this.getHistoryPoint();
            this.getProfile();
            this.getExpirePoint();
        },
        setCurrentDate() {
            const currentMonth = moment().month();
            const correntYear = moment().year();
            const repYear = this.replaceYears(
                this.getYearByLocale(correntYear)
            );
            const setDate = "" + currentMonth + "/" + repYear;
            this.fullDatePoint = setDate;
        },
        checkJson(item) {
            let result = false;
            try {
                JSON.parse(item).forEach((element) => {
                    if ("id" in element) {
                        if (element.id.includes("NescafeStreetCafe_Menu")) {
                            result = true;
                        }
                    } else if ("Id" in element) {
                        if (element.Id.includes("NescafeStreetCafe_Menu")) {
                            result = true;
                        }
                    }
                });
                return result;
            } catch {
                return result;
            }
        },
        checkType(item = {}) {
            let result = false;
            if (item.Message) {
                try {
                    result =
                        JSON.parse(item.Message)[0].Id ==
                            "Buynescafestreetcafe" ||
                        JSON.parse(item.Message)[0].Id == "earn_qty";
                } catch {
                    return result;
                }
            }
            return result;
        },
        getHistoryPoint() {
            this.handleLoading(true);
            let paramgetPointLog = {};

            paramgetPointLog.date = this.dateforfind.startDate;
            paramgetPointLog.nextpage = this.nextdataForPointLog
                ? this.nextdataForPointLog
                : "";

            const token = Account.getToken();
            BzbsHistory.getPointLog(token, paramgetPointLog).subscribe(
                (result) => {
                    if (result.data.length > 0) {
                        _.forEach(result.data, (item) => {
                            if (item.Type !== "redeem") {
                                if (this.checkJson(item.Message)) {
                                    item = {
                                        ...item,
                                        Mission: true,
                                    };
                                    this.historyPoint.push(item);
                                } else {
                                    this.historyPoint.push(item);
                                }
                            }
                        });
                        if (this.historyPoint.length == 25) {
                            this.isshowmorePointLog = true;
                            this.nextdataForPointLog =
                                this.historyPoint[
                                    this.historyPoint.length - 1
                                ].RowKey;
                        }
                        this.handleLoading(false);
                    } else {
                        this.handleLoading(false);
                    }
                },
                (err) => {
                    this.handleLoading(false);
                    console.log("err getPointLog :: ", err);
                }
            );
        },
        getProfile() {
            BzbsApi.getProfile(
                this.cacheHelper.getCache("BzbsUser").token
            ).then((response) => {
                this.profile = response.data;
            });
        },
        getExpirePoint() {
            BzbsApi.getExpirePoint(
                this.cacheHelper.getCache("BzbsUser").token
            ).then((response) => {
                if (response.data) {
                    if (response.data.expiring_points.length > 0) {
                        this.expire_point.points =
                            response.data.expiring_points[0].points;

                        const pointExpireTime =
                            response.data.expiring_points[0].time;
                        const month_number =
                            moment.unix(pointExpireTime).format("MM") - 1;

                        this.expire_point.date = Number(
                            moment.unix(pointExpireTime).format("DD")
                        );
                        this.expire_point.month =
                            this.lbl.date.month_short[month_number];
                        this.expire_point.year =
                            parseInt(
                                moment.unix(pointExpireTime).format("YYYY")
                            ) + 543;
                    }
                }
            });
        },
        generateArrayOfFulldate() {
            let objGetMonth = {};
            let arrGetMonth = [];
            this.lbl.date.month_full.forEach((element, i) => {
                objGetMonth = {
                    id: i,
                    text: element,
                };
                arrGetMonth.push(objGetMonth);
            });
            const monthFull = [...arrGetMonth].sort(function (a, b) {
                return b.id - a.id;
            });
            let objMonth = {};
            let fullDate = [];
            this.yearsRange.forEach((eleYear) => {
                monthFull.forEach((eleMonth) => {
                    objMonth = {
                        id: eleMonth.id + "/" + eleYear,
                        monthName: eleMonth.text + " " + eleYear,
                    };
                    fullDate.push(objMonth);
                });
            });
            this.fullDateRange = fullDate;
        },
        generateArrayOfYears() {
            var max = new Date().getFullYear();
            var min = max - 1;
            max = this.getYearByLocale(max);
            min = this.getYearByLocale(min);
            var years = [];
            for (var i = max; i >= min; i--) {
                years.push(this.replaceYears(i));
            }

            this.yearsRange = years;
        },
        afterFilter(date) {
            this.dateforfind = {};
            this.historyPoint = [];
            this.nextdataForPointLog = "";
            this.dateforfind = date;
            this.getHistoryPoint();
        },
        replaceYears(isYear) {
            if (isYear) {
                const rpYear = isYear.toString().slice(2, 4);
                return rpYear;
            }
        },
        getYearByLocale: function (year) {
            return parseInt(year) + 543;
        },
        handleChangeDate() {
            this.getHistoryPoint();
        },
        addstrzeor(value) {
            value = ("0" + (1 + value)).slice(-2);
            return value;
        },
        substring(value) {
            var str = value;
            var res = String(str);
            value = res.substr(1);
            return value;
        },
        dateTH(date) {
            if (date) {
                const dataYear =
                    parseInt(moment.unix(date).format("YYYY")) + 543;
                const dataMonth = moment.unix(date).format("MM");
                const dataDay = Number(moment.unix(date).format("DD"));
                var timestamptolctime = moment.unix(date).format("HH:mm");

                const setDateTime =
                    dataDay +
                    " / " +
                    dataMonth +
                    " / " +
                    dataYear +
                    " " +
                    timestamptolctime;
                return setDateTime;
            }
        },
        dateShortFormat: function (timestamp, isdonotshowtime) {
            // moment.locale(Locale.getLocale())
            var strDate = moment.unix(timestamp).format("DD MMM ");
            var year = moment.unix(timestamp).format("YY");
            var timestamptolctime = moment.unix(timestamp).format("HH:mm");
            year = this.getYearByLocale(year);
            // if (moment.locale(Locale.getLocale()) == 'th') {
            //     year = this.substring(year)
            // }
            var time = "";
            if (isdonotshowtime) {
                time = strDate + year;
            } else {
                time = strDate + year + " - " + timestamptolctime;
            }

            return time;
        },
        handleScroll() {
            var scrollHeight = document.documentElement.scrollHeight;
            var scrollHeightpercent = (scrollHeight * 70) / 100;
            if (
                document.documentElement.scrollTop +
                    document.documentElement.clientHeight >
                    scrollHeightpercent &&
                this.isshowmorePointLog
            ) {
                if (this.isshowmorePointLog) {
                    this.isshowmorePointLog = false;
                    this.getHistoryPoint();
                }
            }
        },
    },
};
</script>

<style lang="scss">
@import "@/module/History/page/SelectHistory.scss";
</style>

<style lang="scss" scoped>
@import "@/style/_mixin.scss";
@import "@/module/History/page/TableHistory.scss";
.wrapper-bg {
    padding-bottom: 0;
    .container-history-earn-point {
        overflow: auto;
        margin-top: 15px;
        .earn-left {
            .date {
                color: $color-brown-600;
                font-size: 12px;
            }
            .detail {
                font-size: 16px;
                line-height: 1.4em;
                margin-top: 5px;
            }
        }
    }
}
</style>
